import React from "react";
import "../Navigation/css/NavBar.scss";
import {Black} from "../../theme/styles";
import ReactJson from "react-json-view";
import authenticate_post_request from "../../json/authenticate/authenticate-post-request.json";
import authenticate_post_response from "../../json/authenticate/authenticate-post-response.json";


export default function AuthenticatePOST() {

    return (
        <div style={{paddingLeft: "20px", paddingRight: "30px"}}>
            <p style={{fontSize: "24px", fontWeight: "400", color: Black}}>Authenticate POST</p>
            <p style={{fontSize: "16px", fontWeight: "400", color: Black}}>Overview</p>

            <p style={{fontSize: "14px", fontWeight: "400", color: Black, marginLeft: "20px"}}>
                This API creates the X-Enlil-AccessToken and X-Enlil-RefreshToken required to traffic all Enlil REST APIs.
            </p>
            <br/>
            <p style={{fontSize: "16px", fontWeight: "400", color: Black}}>Parameters</p>
            <ul style={{fontSize: "14px", fontWeight: "400", color: Black}}>
                <li style={{marginTop: "20px"}}>Header Parameters
                    <li style={{marginTop: "20px", marginLeft: "20px"}}>X-Enlil-AccessToken (Required String)</li>
                    <li style={{marginTop: "10px", marginLeft: "40px"}}>The X-Enlil-AccessToken is obtained during the authentication process and expires after 90 days.</li>
                </li>
                <li style={{marginTop: "20px"}}>POST Body
                    <p style={{fontFamily: "Courier New", fontSize: "12px"}}>
                        <ReactJson src={authenticate_post_request} collapseStringsAfterLength={75} collapsed={4}/>
                    </p>
                </li>
            </ul>
            <br/>
            <p style={{fontSize: "16px", fontWeight: "400", color: Black}}>Example</p>
            <ul style={{fontSize: "14px", fontWeight: "400", color: Black}}>
                A POST execution will look as follows.
                <span style={{fontFamily: "Courier New", fontSize: "14px",}}><br/><br/>curl -d '&#123;"X-Enlil-ApiKey":"&#60;key&#62;", "X-Enlil-SecretKey":"&#60;key&#62;"&#125;' -H "X-Enlil-AccessToken: &#60;token1&#62; -X POST "https://api.integrate.enlil.io/t3/v1/authenticate"</span><br/><br/>
                It will respond with a payload similar to the following.<br/><br/>
                <p style={{fontFamily: "Courier New", fontSize: "12px"}}>
                    <ReactJson src={authenticate_post_response} collapseStringsAfterLength={75} collapsed={4}/>
                </p>
                <br/>
            </ul>
            <p style={{fontSize: "16px", fontWeight: "400", color: Black}}>Error Codes</p>
            <ul style={{fontSize: "14px", fontWeight: "400", color: Black}}>
                <li style={{marginTop: "20px"}}>400 CC-DNXE-ASI8 - Unauthorized:</li>
                <li style={{marginTop: "10px", marginLeft: "40px"}}>Description: This error results when the X-Enlil-AccessToken passed has a header is invalid.</li>
                <li style={{marginTop: "10px", marginLeft: "40px"}}>HTTP Code: 400</li>
            </ul>
            <ul style={{fontSize: "14px", fontWeight: "400", color: Black}}>
                <li style={{marginTop: "20px"}}>400 CC-OEID-KDIE - Invalid payload</li>
                <li style={{marginTop: "10px", marginLeft: "40px"}}>Description: Invalid payload field: ApiKey</li>
                <li style={{marginTop: "10px", marginLeft: "40px"}}>HTTP Code: 400</li>
            </ul>
            <ul style={{fontSize: "14px", fontWeight: "400", color: Black}}>
                <li style={{marginTop: "20px"}}>400 CC-19FB-4270 - Invalid payload</li>
                <li style={{marginTop: "10px", marginLeft: "40px"}}>Description: Invalid payload field: SecretKey</li>
                <li style={{marginTop: "10px", marginLeft: "40px"}}>HTTP Code: 400</li>
            </ul>
            <ul style={{fontSize: "14px", fontWeight: "400", color: Black}}>
                <li style={{marginTop: "20px"}}>400 CC-746A-4E73 - Invalid credentials</li>
                <li style={{marginTop: "10px", marginLeft: "40px"}}>Description: FailCount: n - Each time the user provides invalid credentials, a fail count is incremented. The user is allowed 10 consecutive failures, before a 24 hour lockout occurs.</li>
                <li style={{marginTop: "10px", marginLeft: "40px"}}>HTTP Code: 400</li>
            </ul>
            <ul style={{fontSize: "14px", fontWeight: "400", color: Black}}>
                <li style={{marginTop: "20px"}}>400 CC-JFH4-IR78 - Application Inactive</li>
                <li style={{marginTop: "10px", marginLeft: "40px"}}>Description: The Application associated to the API Key is inactive.</li>
                <li style={{marginTop: "10px", marginLeft: "40px"}}>HTTP Code: 400</li>
            </ul>
            <ul style={{fontSize: "14px", fontWeight: "400", color: Black}}>
                <li style={{marginTop: "20px"}}>400 CC-IR45-KIT5 - API Key Inactive</li>
                <li style={{marginTop: "10px", marginLeft: "40px"}}>Description: The API Key is inactive.</li>
                <li style={{marginTop: "10px", marginLeft: "40px"}}>HTTP Code: 400</li>
            </ul>
            <br/>
        </div>
    )
}